import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'antd';
import BugHerdLogo from './assets/logo-BH.svg';
import styles from './index.module.css';
import Player from '@vimeo/player';
import track, { trackPage } from '../../utils/analytics';
import { getLangKey } from 'models/Language';
import * as translations from './strings';
const strings = translations[getLangKey()];
import cx from 'classnames';

interface Organization {
  id: number;
}

interface Project {
  id: number;
}

interface WelcomeDemoVideoProps {
  organization: Organization;
  project: Project;
}

const WelcomeDemoVideo: React.FC<WelcomeDemoVideoProps> = ({
  organization,
  project
}) => {
  const [canContinue, setCanContinue] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const playerRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    trackPage('Onboarding welcome demo video');
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setCanContinue(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (playerRef.current) {
      const player = new Player(playerRef.current);

      player.on('play', async () => {
        track('Onboarding welcome demo video played', {});
        setCanContinue(true);
      });
    }
  }, [playerRef]);

  return (
    <div className={cx(styles.container, styles.welcomeDemoVideoContainer)}>
      <div className={styles.staticNavbar}>
        <BugHerdLogo />
        <span className={styles.welcomeText}>{strings.welcome}</span>
      </div>
      <div className={styles.roundedBorderContainer}>
        <div className={styles.content}>
          <h1>{strings.watchThisDemo}</h1>
          <p>{strings.watchThisDemoDescription}</p>
          <Button
            className={styles.continueButton}
            type="primary"
            size="large"
            disabled={!canContinue}
            onClick={() => {
              track('onboarding welcome video continue clicked', {});
              window.location.href = `/organizations/${organization.id}/projects/${project.id}`;
            }}
          >
            {canContinue ? 'Continue' : `Continue in ${countdown} sec`}
          </Button>
          <div className={styles.videoContainer}>
            <iframe
              ref={playerRef}
              src="https://player.vimeo.com/video/799732517"
              width={640}
              height={360}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeDemoVideo;
